<script>
/**
 * Fix return value of input when the value is cleared or erased
 * instead of returning an empty string (default html behavior)
 * return a null value
 *
 * original files
 * https://github.com/ElemeFE/element/blob/dev/packages/input/src/input.vue
*/
import { Input } from 'element-ui';

export default {
  name: 'NullableInput',
  props: {
    nullValue: {
      type: [Number, String],
      default: null
    }
  },
  extends: Object.assign({}, Input, {
    render: Input.render,
    methods: Object.assign({}, Input.methods, {
      /**
       * override all methods emitting input value
       * return null if the input value is cleared or erased
      */
      clear() {
        this.$emit('input', this.nullValue);
        this.$emit('change', this.nullValue);
        this.$emit('clear');
      },
      handleInput(event) {
        if (this.isComposing) {
          return;
        }
        if (event.target.value === this.nativeInputValue) {
          return;
        }
        this.$emit('input', event.target.value === '' ? this.nullValue : event.target.value);
        this.$nextTick(this.setNativeInputValue);
      },
      handleChange(event) {
        this.$emit('change', event.target.value === '' ? this.nullValue : event.target.value);
      }
    })
  })
};
</script>
